import { ItemTypeEnum, ProjectorItemsEntity, SlimItemsEntity } from '@galabid/gb-dashboard/item/data-access'
import { LockTypeEnum } from 'libs/shared/models/shared.models'

export const PRESENTER_ITEM_TABLE_TEST_ITEMS: Array<ProjectorItemsEntity | SlimItemsEntity> = [
  {
    uuid: 'test-item-001',
    auction: 'test-auction',
    alias: 'A1',
    name: 'Weekend Getaway: Boutique Hotel & Brunch for Two',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 1,
    bidding_item: {
      uuid: 'test-bidding-001',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 25,
      pay_now: true,
      reserve_price: 250,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 150,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 500,
  },
  {
    uuid: 'test-item-002',
    auction: 'test-auction',
    alias: 'A2',
    name: 'Private Cooking Class: Seasonal Pasta Night',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 2,
    bidding_item: {
      uuid: 'test-bidding-002',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 20,
      pay_now: true,
      reserve_price: null,
      reserve_price_enabled: false,
      sealed_bid_item: false,
      starting_price: 120,
      units_per_person: 1,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 400,
  },
  {
    uuid: 'test-item-003',
    auction: 'test-auction',
    alias: 'A3',
    name: 'Signed Football Jersey (Framed)',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 3,
    bidding_item: {
      uuid: 'test-bidding-003',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 15,
      pay_now: true,
      reserve_price: 150,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 80,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 350,
  },
  {
    uuid: 'test-item-004',
    auction: 'test-auction',
    alias: 'A4',
    name: 'Garden-to-Table Hamper (Locally Sourced)',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 4,
    bidding_item: {
      uuid: 'test-bidding-004',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 10,
      pay_now: true,
      reserve_price: null,
      reserve_price_enabled: false,
      sealed_bid_item: false,
      starting_price: 60,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: 1,
    market_value: 200,
  },
  {
    uuid: 'test-item-005',
    auction: 'test-auction',
    alias: 'A5',
    name: 'VIP Theatre Night: Best Seats + Interval Drinks',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 5,
    bidding_item: {
      uuid: 'test-bidding-005',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 25,
      pay_now: true,
      reserve_price: 350,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 200,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 650,
  },
  {
    uuid: 'test-item-006',
    auction: 'test-auction',
    alias: 'B1',
    name: 'Live Auction: Dinner with a Local Chef (8 Guests)',
    item_type: ItemTypeEnum.Live,
    images: [],
    order: 6,
    bidding_item: {
      uuid: 'test-bidding-006',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: true,
      hide_bid_slider: false,
      live_auction_item: true,
      max_bid_enabled: true,
      minimum_increment: 50,
      pay_now: true,
      reserve_price: 800,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 500,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 1500,
  },
  {
    uuid: 'test-item-007',
    auction: 'test-auction',
    alias: 'B2',
    name: 'Live Auction: Backstage Tour + Meet & Greet',
    item_type: ItemTypeEnum.Live,
    images: [],
    order: 7,
    bidding_item: {
      uuid: 'test-bidding-007',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: true,
      hide_bid_slider: true,
      live_auction_item: true,
      max_bid_enabled: true,
      minimum_increment: 50,
      pay_now: true,
      reserve_price: 500,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 300,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 900,
  },
  {
    uuid: 'test-item-008',
    auction: 'test-auction',
    alias: 'C1',
    name: 'Sealed Bid: Executive Boardroom Lunch (6 Guests)',
    item_type: ItemTypeEnum.Sealed,
    images: [],
    order: 8,
    bidding_item: {
      uuid: 'test-bidding-008',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: true,
      live_auction_item: false,
      max_bid_enabled: false,
      minimum_increment: 0,
      pay_now: true,
      reserve_price: 400,
      reserve_price_enabled: true,
      sealed_bid_item: true,
      starting_price: 0,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 800,
  },
  {
    uuid: 'test-item-009',
    auction: 'test-auction',
    alias: 'C2',
    name: 'Sealed Bid: Naming Rights for a Dessert (One Night Only)',
    item_type: ItemTypeEnum.Sealed,
    images: [],
    order: 9,
    bidding_item: {
      uuid: 'test-bidding-009',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: true,
      live_auction_item: false,
      max_bid_enabled: false,
      minimum_increment: 0,
      pay_now: true,
      reserve_price: 250,
      reserve_price_enabled: true,
      sealed_bid_item: true,
      starting_price: 0,
      units_per_person: 1,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 500,
  },
  {
    uuid: 'test-item-010',
    auction: 'test-auction',
    alias: 'D1',
    name: 'Raffle: Luxury Wellness Hamper',
    item_type: ItemTypeEnum.Raffle,
    images: [],
    order: 10,
    bidding_item: null,
    purchase_item: null,
    donation_item: null,
    raffle_item: {
      uuid: 'test-raffle-010',
      auction: 'test-auction',
      pay_now: true,
      ticket_price: 10,
      prizes_available: 1,
      max_tickets_per_person: 20,
      item: '',
      item_type: ItemTypeEnum.Raffle,
    },
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 250,
  },
  {
    uuid: 'test-item-011',
    auction: 'test-auction',
    alias: 'D2',
    name: 'Raffle: “Golden Ticket” Reserved Parking Spot',
    item_type: ItemTypeEnum.Raffle,
    images: [],
    order: 11,
    bidding_item: null,
    purchase_item: null,
    donation_item: null,
    raffle_item: {
      uuid: 'test-raffle-011',
      auction: 'test-auction',
      pay_now: true,
      ticket_price: 5,
      prizes_available: 1,
      max_tickets_per_person: 30,
    },
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 120,
  },
  {
    uuid: 'test-item-012',
    auction: 'test-auction',
    alias: 'E1',
    name: 'Purchase: Celebration Centrepiece (Pre-Order)',
    item_type: ItemTypeEnum.Purchase,
    images: [],
    order: 12,
    bidding_item: null,
    purchase_item: {
      uuid: 'test-purchase-012',
      auction: 'test-auction',
      pay_now: true,
      unit_price: 35,
      units_per_person: 2,
      units_remaining: 50,
    },
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: 50,
    market_value: 35,
  },
  {
    uuid: 'test-item-013',
    auction: 'test-auction',
    alias: 'E2',
    name: 'Purchase: Lucky Dip Envelope (No Peeking)',
    item_type: ItemTypeEnum.Purchase,
    images: [],
    order: 13,
    bidding_item: null,
    purchase_item: {
      uuid: 'test-purchase-013',
      auction: 'test-auction',
      pay_now: true,
      unit_price: 15,
      units_per_person: 5,
      units_remaining: 200,
    },
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: 200,
    market_value: 15,
  },
  {
    uuid: 'test-item-014',
    auction: 'test-auction',
    alias: 'F1',
    name: 'Donation: Support a Classroom Resource Pack',
    item_type: ItemTypeEnum.Donation,
    images: [],
    order: 14,
    bidding_item: null,
    purchase_item: null,
    donation_item: {
      uuid: 'test-donation-014',
      auction: 'test-auction',
      pay_now: true,
      minimum_donation: 10,
    },
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 0,
  },
  {
    uuid: 'test-item-015',
    auction: 'test-auction',
    alias: 'F2',
    name: 'Donation: Sponsor a Volunteer Thank-You Kit',
    item_type: ItemTypeEnum.Donation,
    images: [],
    order: 15,
    bidding_item: null,
    purchase_item: null,
    donation_item: {
      uuid: 'test-donation-015',
      auction: 'test-auction',
      pay_now: true,
      minimum_donation: 25,
    },
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 0,
  },
  {
    uuid: 'test-item-016',
    auction: 'test-auction',
    alias: 'A6',
    name: 'Afternoon Tea: Vintage Tearoom Experience (4 Guests)',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 16,
    bidding_item: {
      uuid: 'test-bidding-016',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 10,
      pay_now: true,
      reserve_price: 150,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 90,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 320,
  },
  {
    uuid: 'test-item-017',
    auction: 'test-auction',
    alias: 'A7',
    name: 'Art Print: Limited Edition, Signed by the Artist',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 17,
    bidding_item: {
      uuid: 'test-bidding-017',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 10,
      pay_now: true,
      reserve_price: 120,
      reserve_price_enabled: true,
      sealed_bid_item: false,
      starting_price: 70,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: 1,
    market_value: 250,
  },
  {
    uuid: 'test-item-018',
    auction: 'test-auction',
    alias: 'E3',
    name: 'Purchase: Photo Booth Package (3 Strips)',
    item_type: ItemTypeEnum.Purchase,
    images: [],
    order: 18,
    bidding_item: null,
    purchase_item: {
      uuid: 'test-purchase-018',
      auction: 'test-auction',
      pay_now: true,
      unit_price: 8,
      units_per_person: 10,
      units_remaining: 500,
    },
    donation_item: null,
    raffle_item: null,
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: 500,
    market_value: 8,
  },
  {
    uuid: 'test-item-019',
    auction: 'test-auction',
    alias: 'D3',
    name: 'Raffle: Signed Cookbook + “Chef’s Choice” Spice Set',
    item_type: ItemTypeEnum.Raffle,
    images: [],
    order: 19,
    bidding_item: null,
    purchase_item: null,
    donation_item: null,
    raffle_item: {
      uuid: 'test-raffle-019',
      auction: 'test-auction',
      pay_now: true,
      ticket_price: 5,
      prizes_available: 5,
      max_tickets_per_person: 50,
    },
    voucher_enabled: false,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: false,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 90,
  },
  {
    uuid: 'test-item-020',
    auction: 'test-auction',
    alias: 'A8',
    name: 'Guided City Walk: Hidden History & Sweet Treat Stop',
    item_type: ItemTypeEnum.Bidding,
    images: [],
    order: 20,
    bidding_item: {
      uuid: 'test-bidding-020',
      allow_buy_now: false,
      buy_now_price: null,
      enable_live_auction: false,
      hide_bid_slider: false,
      live_auction_item: false,
      max_bid_enabled: true,
      minimum_increment: 10,
      pay_now: true,
      reserve_price: null,
      reserve_price_enabled: false,
      sealed_bid_item: false,
      starting_price: 50,
      units_per_person: null,
      bid_strength_enabled: false,
      bid_strength_percentage: null,
      has_bidding_purchases: false,
      auction: '',
      bidding_purchases: [],
      hide_bidder: false,
      hide_reserve_price: false,
      hide_price: false,
      hide_status_badge: false,
      hide_units_available: false,
      item: '',
      item_type: ItemTypeEnum.Bidding,
      minimum_next_bid: 50,
      outbid_sms: false,
      outbid_notification: true,
      units_available: 1,
      units_remaining: 1,
      winning_bids: [],
    },
    purchase_item: null,
    donation_item: null,
    raffle_item: null,
    voucher_enabled: true,
    tax: null,
    ioc: false,
    ioc_cost: 0,
    image_cover: false,
    has_activity: true,
    is_visible: true,
    lock: LockTypeEnum.None,
    quantity: null,
    market_value: 180,
  },
]
